<template>
  <div> {{ userDetails }} </div>
</template>


<script>
  export default {
    name: 'userDetails',
    props: {
      user: {
        required: true,
        type: Object,
      },
    },
    computed: {
      userDetails() {
        return `${this.user.firstname} ${this.user.lastname} (${this.user.email})`;
      },
    },
  };
</script>




// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/reported_to_bid_artworks/user_details.vue?41a932ce